// 此处gid为appid
import md5 from 'js-md5'
import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
let msg =null

    function jointUrl(data){
        var params = '';
        for(var key in data){
        params += key + '=' + data[key] + '&';
        }
        params = params.replace(/&{1}$/,'');
        return params;
    }

  function  getSign(options, appkey){
    const key = appkey || Vue.prototype.config.key;
    return md5(Vue.prototype.util.jointUrl(options) + key).toLowerCase();
  }
export function upDataRole(roles){
    let roleUp = {
        type:roles.type,//上报行为：1选择服务器，2创建角色 3登录游戏 4 角色升级 5退出登录
        channel:'1',
        appid: JSON.parse(sessionStorage.getItem('h5LoginData')).appid,
        deviceID:JSON.parse(sessionStorage.getItem('h5LoginData')).machine_code,
        userID:JSON.parse(sessionStorage.getItem('accountData')).uid,//app_uid  uid
        serverID:roles.serverID,
        serverName:roles.serverName,
        roleID:roles.roleID,
        roleName:roles.roleName,
        roleLevel:roles.roleLevel,
        money:roles.money,
        vip:roles.vip
    }
    let keys = JSON.parse(sessionStorage.getItem('h5LoginData')).appkey
    roleUp.sign = getSign(roleUp,keys)
    axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=report_data', qs.stringify(roleUp)).then(res => {
        if (res.data.status == 1) {
            console.log(res.data.msg,'游戏上报成功');
            window.parent.postMessage({type:'submitExtra',info:JSON.stringify(res.data)}, '*')
        } else {
            msg = res.data.msg
            setTimeout(() => {
                msg = null
            }, 2000)
        }
    }).catch(o => {
        msg = '请求失败'
        setTimeout(() => {
            msg = null
        }, 5000)
    })
}
